import React from 'react';
import { Helmet } from 'react-helmet';

function Onboarding_Seo() {
  return (
    <div>
      <Helmet>
                <title>How to scan your photo ID on our app? | FinestPay</title>
                <meta name="description" content="IDScan is easy and quick process. Just position your ID vertically and take a picture of it using our app. We read the ID details and save your typing efforts." />
                <meta property="og:title" content="How to scan your photo ID on our app? | FinestPay" />
                <meta property="og:description" content="IDScan is easy and quick process. Just position your ID vertically and take a picture of it using our app. We read the ID details and save your typing efforts." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/onboarding"/>
            </Helmet>
    </div>
  )
}

export default Onboarding_Seo
